module.exports = __webpack_public_path__ + "img/speaker.c932db9d.svg";